const Skill = {
    name: undefined,
    category: undefined,
    percentage: undefined,
}

export default Skill;